import { createSlice } from '@reduxjs/toolkit'
import { getAllCustomers, getCustomer, createDebitor, updateDebitor, deleteDebitor } from './asyncCustomers'

const initialState = {
  isLoading: true,
  isError: false,
  data: [],
  customer: {},
  meta: {}
}

export const CUSTOMERS_SLICE = createSlice({
  name: 'customers',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data ?? [];
        state.meta = action.payload?.meta ?? {};
      })
      .addCase(getAllCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true
      })
      .addCase(createDebitor.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(createDebitor.fulfilled, (state, action) => {
        state.isLoading = false;
        // Optionally prepend the new debitor to the list if available
        if (action.payload?.data) {
          state.data = [action.payload.data, ...state.data];
        }
      })
      .addCase(createDebitor.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateDebitor.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(updateDebitor.fulfilled, (state, action) => {
        state.isLoading = false;
        const updated = action.payload?.data;
        if (updated?.id) {
          state.data = state.data.map((item) => (item.id === updated.id ? updated : item));
        }
      })
      .addCase(updateDebitor.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(deleteDebitor.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(deleteDebitor.fulfilled, (state, action) => {
        state.isLoading = false;
        const deletedId = action.payload?.id;
        if (deletedId) {
          state.data = state.data.filter((item) => item.id !== deletedId);
        }
      })
      .addCase(deleteDebitor.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
  },
})

// Action creators are generated for each case reducer function

export default CUSTOMERS_SLICE.reducer